import { lazyLoad } from "utils/loadable";

export const AdminPriceSetup = lazyLoad(
  () => import("./index"),
  (module) => module.AdminPriceSetup
);
